// extracted by mini-css-extract-plugin
export default {"range":"style_range__RuTIg","range2":"style_range2__n4cxX","btnWhy":"style_btnWhy__ADj50","gridSrevices":"style_gridSrevices__HM-FM"};